/* Microphone Check */
export const Microphone_Check = `Unable to detect recording device. Please check your headset and try again.`;
export const Microphone_Check_With_Code = `${Microphone_Check} (BMC0001)`;

/* Speaking Interaction */
export const SpeakingInteraction_Recorder_Start = `Unable to detect recording device. Please check your headset and try again.`;
export const SpeakingInteraction_Recorder_Start_With_Code = `${SpeakingInteraction_Recorder_Start} (BSP0001)`;
export const SpeakingInteraction_Times_Up = `<p>The detected audio recording is unacceptable.</p>
<p>There may be a problem with the audio recording device being used or the operating system settings for this computer.</p>
<p>Please inform your Test Supervisor to resolve this issue.</p>`;

/* Exit */
export const Exit_ExitCode = "The CTC code provided is not correct. This code was provided when first initializing the application. (BEX0001)";
export const Exit_ExitReason = "Please select a reason for exiting the application. (BEX0002)";
export const Exit_ExitDescription = "The reason chosen must be accompanied with a description. Please provide a description. (BEX0003)";

/* Lock Screen */
export const LockScreen_ExitCode = "The CTC code provided is not correct. This code was provided when first initializing the application. (BLK0001)";

/* Http Call */
export const Http_Unknown = "The browser could not connect to the server. An unknown error occurred. Please contact a member of staff for more details. (BHT0001)";

/* Responses */
export const Response_Saving_Missing_Blobs = "<p>A problem was detected while trying to save speaking data.</p><p>Please inform a staff member to restart Secure Browser. (BRP0001)</p>";
export const Response_Saving_Server_Call = "<p>A problem was detected while trying to communicate with the test.</p><p>Please inform a member of staff to resolve this issue.</p>";

/* Test Navigation */
export const Navigation_Response_Saving = "Responses could not be saved. An unknown error occurred. Please contact a member of staff for more details. (BTN0001)";



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/errors/constants.ts